import {Entity} from "../../core/commons/entity";
import {User} from "../../core/domain/user";
/**
 * Created by Lauta on 15/3/2017.
 */
export class Topic implements Entity{
    id: number;
    name: string;
    mediator: User;

    constructor(value: Object = {}) {
        Object.assign(this, value);
        if (this.mediator)
            this.mediator = new User(this.mediator);
    }

}


// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/topic.ts